import { Helmet } from 'react-helmet-async';

interface Props {
  title: string;
}

export const PageHeader: React.FC<Props> = (props) => {
  return (
    <Helmet>
      <title>{props.title}</title>
      <meta name="description" content="Cloud workspaces where you and AI agents build together." />
    </Helmet>
  );
};
